import { StudyParticipant } from '../models/StudyParticipant';

/**
 * Qualification outcome for the completion screen.
 */
export function resolveQualificationOutcome({
  studyParticipantId,
  studyParticipants,
  participantQualified,
  isPublicQualification
}: {
  studyParticipantId?: number;
  studyParticipants?: StudyParticipant[];
  participantQualified?: boolean;
  isPublicQualification?: boolean;
}): { qualified: boolean; isPublicQualification?: boolean } {
  const studyParticipant = studyParticipants?.find(
    sp => Number(sp.id) === Number(studyParticipantId)
  );
  if (!studyParticipant) {
    return { qualified: Boolean(participantQualified), isPublicQualification };
  }
  return {
    qualified: Boolean(studyParticipant.qualified),
    isPublicQualification:
      studyParticipant.study?.isPublic ?? isPublicQualification
  };
}
